import { getInviteToken, clearInviteToken } from "./invite-pending";
import * as productAccessApi from "../api/product-access";

/**
 * If a product-access invite token is pending in sessionStorage, accept it.
 * Returns the productId when acceptance succeeds; otherwise null (org invite,
 * already accepted, or invalid token).
 */
export async function acceptPendingProductInvite(
  accessToken: string,
): Promise<string | null> {
  const inviteToken = getInviteToken();
  if (!inviteToken) return null;

  try {
    const result = await productAccessApi.acceptProductInvite(
      accessToken,
      inviteToken,
    );
    clearInviteToken();
    return result.productId ?? null;
  } catch {
    return null;
  }
}
